import { render, staticRenderFns } from "./SessionsBatchesFilters.vue?vue&type=template&id=636bb214"
import script from "./SessionsBatchesFilters.vue?vue&type=script&lang=js"
export * from "./SessionsBatchesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports